import includes from "lodash/includes";
import styled from "styled-components";
const SIZES = {
    BLUR_RADIUS: 5
};
export default {
    Container: styled.div.withConfig({
        shouldForwardProp: (prop) => !includes(["showCancelPanel"], prop)
    }) `
    ${({ showCancelPanel }) => showCancelPanel && ` > :first-child { filter: blur(${SIZES.BLUR_RADIUS}px); }`}
  `
};
